import * as React from 'react';
import { cn } from './utils';

type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline';

const variantClasses: Record<BadgeVariant, string> = {
  default: 'bg-primary text-white border-transparent',
  secondary: 'bg-gray-100 text-gray-700 border-gray-200',
  destructive: 'bg-red-50 text-red-700 border-red-200',
  outline: 'border border-gray-300 text-gray-700 bg-transparent',
};

export interface BadgeProps extends React.ComponentProps<'span'> {
  variant?: BadgeVariant;
}

function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium font-inter',
        variantClasses[variant],
        className
      )}
      {...props}
    />
  );
}

export { Badge };
